import { __awaiter } from "tslib";
import { BaseService } from "../../base";
export class SoapLogService extends BaseService() {
    static get entity() {
        return "soap_log";
    }
    static get responseName() {
        return "soap_logs";
    }
    static filterByInterconsultId(interconsult_id) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.submit({
                method: "post",
                path: "filter",
                data: { interconsult_id },
            });
        });
    }
}
